export default function convertToBase64(inputFile) {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {

    reader.onerror = () => {
      reader.abort();
      console.log("Problem parsing input file.");
      // reject(new DOMException("Problem parsing input file."));
    };
    reader.onload = () => {
      resolve(reader.result.split(',').pop());
    };

    reader.readAsDataURL(inputFile);
  });
}
